import db from "@/database";

export const findAll = () => db.flowType.toArray();

export const findOne = (id) => db.flowType.get(id);
